import { jsx as _jsx } from "react/jsx-runtime";
import { useRecordContext } from 'react-admin';
import { Stack } from '@mui/material';
import { FieldDiff } from './FieldDiff';
/**
 * Render a diff between the current record and the reference record.
 *
 * To be used inside a diffElement. Renders all fields of the record.
 *
 * @example
 * import { Stack } from '@mui/material';
 * import { DefaultDiffElement } from '@react-admin/ra-history';
 *
 * const PostDiff = () => <DefaultDiffElement />;
 */
export var DefaultDiffElement = function () {
    var record = useRecordContext();
    if (!record)
        return null;
    var fields = Object.keys(record);
    return (_jsx(Stack, { sx: {
            gap: 1,
        }, children: fields.map(function (field) { return (_jsx(FieldDiff, { source: field }, field)); }) }));
};
